
'use strict';

angular.module('ringbaPortal')
  .controller('SignupController', function (
    $q,
    $scope,
    $state,
    $timeout,
    authService
  ) {
    const self = this;

    this.savedSuccessfully = false;
    this.message = '';

    this.signupForm = {};
    this.passwordStrengthPercentClass = 'progress-0';
    this.confirmPasswordStrengthPercentClass = 'progress-0';

    $scope.$watch('vm.registration.password', function (newVal) {
      self.calcPasswordStrength(newVal, 'passwordStrengthPercentClass');
    });

    $scope.$watch('vm.registration.confirmPassword', function (newVal) {
      self.calcPasswordStrength(newVal, 'confirmPasswordStrengthPercentClass');
    });

    this.registration = {
      email: '',
      firstName: '',
      lastName: '',
      password: '',
      confirmPassword: ''
    };

    this.signUp = function () {

      if (self.signupForm.$valid) {
        return authService.saveRegistration(self.registration).then(function () {

          self.savedSuccessfully = true;
          self.message = 'User has been registered successfully, you will be redirected to the login page in 2 seconds.';
          startTimer();

        },
        function (response) {
          const errors = [];
          for (const key in response.data.modelState) {
            for (let i = 0; i < response.data.modelState[key].length; i++) {
              errors.push(response.data.modelState[key][i]);
            }
          }
          self.message = 'Failed to register user due to:' + errors.join(' ');
        });
      } else {
        return $q.when({});
      }
    };

    this.calcPasswordStrength = function (H, strengthPercentField) {
      if (!H) {
        H = '';
      }
      let D = (H.length);
      if (D > 5) {
        D = 5;
      }
      const F = H.replace(/[0-9]/g, '');
      let G = (H.length - F.length);
      if (G > 3) {
        G = 3;
      }
      const A = H.replace(/\W/g, '');
      let C = (H.length - A.length);
      if (C > 3) {
        C = 3;
      }
      const B = H.replace(/[A-Z]/g, '');
      let I = (H.length - B.length);
      if (I > 3) {
        I = 3;
      }
      let E = ((D * 10) - 20) + (G * 10) + (C * 15) + (I * 10);
      if (E < 0) {
        E = 0;
      }
      if (E > 100) {
        E = 100;
      }

      self[strengthPercentField] = 'progress-' + String(Math.floor(E / 10) * 10);
    };

    this.setPassword = function (data) {
      this.registration.password = data.password;
      this.registration.confirmPassword = data.confirmPassword;
    };

    const startTimer = function () {
      $timeout(function () {
        $state.go('login');
      }, 2000);
    };
  });
